import script from "./ProjectSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectSelection.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectSelection.vue?vue&type=style&index=0&id=5627eabc&lang=scss"

const __exports__ = script;

export default __exports__